const QueryString = require('../lib/QueryString').default;
const axios = require("axios").default

var PageWorkDetail = {
  data(){
    return{
      workID: QueryString.parse().id || -1,
      work: {},
      works: [],
      datasource: [],
      title: ''
    }
  },
  computed:{

  },
  created(){
    axios.get('/2021_hanwa/cms/work_calendar.json?t=' + (new Date()).getTime()).then( (res)=> {
      this.works = res.data
      this.datasource = this.works

      this.work = this.works.find((info) => {
        return this.workID == info.ID
      })
      if (!this.work) {
        location.replace('../')
      }
      console.log(this.work)

    })

    //インフォメーション
    // this.work = this.works.find((info) => {
    //   return this.workID == info.ID
    // })
    // if (!this.work) {
    //   // location.replace('../')
    // }
    // console.log(this.work)
  },
  mounted(){
    
  },
  methods: {

  }
}

module.exports = PageWorkDetail